<!-- Add Port Charge Modal -->
<div class="modal fade" [class.show]="show" [style.display]="show ? 'block' : 'none'" tabindex="-1" style="z-index: 1060;">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header border-0 pb-2">
        <h6 class="modal-title fw-semibold">Create Port Charge</h6>
        <button type="button" class="btn-close btn-sm" (click)="onClose()"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body pt-0" style="max-height: 75vh; overflow-y: auto;">
        <form>
          <!-- Basic Information Section - 2 Column Layout -->
          <div class="row g-3 mb-3">
            <!-- Charge Type -->
            <div class="col-md-6">
              <label class="form-label small text-muted">Charge Type</label>
              <select class="form-select form-select-sm" [(ngModel)]="formData.chargeType" name="chargeType">
                <option *ngFor="let type of chargeTypes" [value]="type">{{ type }}</option>
              </select>
            </div>

            <!-- Agent -->
            <div class="col-md-6">
              <label class="form-label small text-muted">Agent</label>
              <select class="form-select form-select-sm" [(ngModel)]="formData.agent" name="agent">
                <option value="" disabled selected>Select Agent</option>
                <option *ngFor="let agent of agentsList" [value]="agent.id">{{ agent.name }}</option>
              </select>
            </div>

            <!-- Port List -->
            <div class="col-md-6">
              <label class="form-label small text-muted">Port</label>
              <select class="form-select form-select-sm" [(ngModel)]="formData.portList" name="portList">
                <option value="" disabled selected>Select Port</option>
                <option *ngFor="let port of portsList" [value]="port.id">{{ port.code }} - {{ port.name }}</option>
              </select>
            </div>

            <!-- Valid Until Date -->
            <div class="col-md-6">
              <label class="form-label small text-muted">Valid Until Date</label>
              <input type="date" class="form-control form-control-sm" [(ngModel)]="formData.validUntilDate" name="validUntilDate" />
            </div>

            <!-- Currency -->
            <div class="col-md-6">
              <label class="form-label small text-muted">Currency</label>
              <select class="form-select form-select-sm" [(ngModel)]="formData.currency" name="currency">
                <option *ngFor="let curr of currencies" [value]="curr">{{ curr }}</option>
              </select>
            </div>
          </div>

          <hr class="my-3" />

          <!-- Container-Specific Charges Section -->
          <h6 class="fw-semibold mb-3" style="font-size: 0.9rem;">Container-Specific Charges</h6>
          <div class="row g-3 mb-3">

            <!-- Handling -->
            <div class="col-md-6">
              <div class="charge-section p-3 border rounded">
                <label class="form-label fw-semibold mb-2">Handling</label>

                <div class="mb-3">
                  <label class="form-label small text-muted">Charge Basis</label>
                  <select class="form-select form-select-sm" [(ngModel)]="formData.handling.chargeBasis" name="handlingChargeBasis">
                    <option value="">Select charge basis</option>
                    <option *ngFor="let cb of chargeBasisList" [value]="cb.displayName" [title]="cb.notes">
                      {{ cb.displayName }}
                    </option>
                  </select>
                </div>

                <!-- Single Value Input (default) -->
                <div *ngIf="!perLoadTypeExpanded.handling" class="mb-3">
                  <label class="form-label small text-muted">Value</label>
                  <input type="number" class="form-control form-control-sm" [(ngModel)]="formData.handling.singleValue" name="handlingSingleValue" placeholder="0">
                </div>

                <!-- Per Load Type Button -->
                <button type="button" class="btn btn-sm btn-outline-secondary mb-2 w-100" (click)="togglePerLoadType('handling')">
                  <i class="bi" [ngClass]="perLoadTypeExpanded.handling ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                  Per Load Type
                </button>

                <!-- Load Type Fields (when expanded) - DYNAMIC -->
                <div *ngIf="perLoadTypeExpanded.handling" class="load-types-table">
                  <div *ngFor="let loadType of containerLoadTypes" class="load-type-row d-flex align-items-center mb-2">
                    <label class="load-type-label">{{ loadType.label }}</label>
                    <input
                      type="number"
                      class="form-control form-control-sm"
                      [(ngModel)]="formData.handling.loadTypes[getLoadTypeKey(loadType.code)]"
                      [name]="'handling' + loadType.code"
                      placeholder="0">
                  </div>
                </div>
              </div>
            </div>

            <!-- Customs Clearance -->
            <div class="col-md-6">
              <div class="charge-section p-3 border rounded">
                <label class="form-label fw-semibold mb-2">Customs Clearance</label>

                <div class="mb-3">
                  <label class="form-label small text-muted">Charge Basis</label>
                  <select class="form-select form-select-sm" [(ngModel)]="formData.customsClearance.chargeBasis" name="customsClearanceChargeBasis">
                    <option value="">Select charge basis</option>
                    <option *ngFor="let cb of chargeBasisList" [value]="cb.displayName" [title]="cb.notes">
                      {{ cb.displayName }}
                    </option>
                  </select>
                </div>

                <div *ngIf="!perLoadTypeExpanded.customsClearance" class="mb-3">
                  <label class="form-label small text-muted">Value</label>
                  <input type="number" class="form-control form-control-sm" [(ngModel)]="formData.customsClearance.singleValue" name="customsClearanceSingleValue" placeholder="0">
                </div>

                <button type="button" class="btn btn-sm btn-outline-secondary mb-2 w-100" (click)="togglePerLoadType('customsClearance')">
                  <i class="bi" [ngClass]="perLoadTypeExpanded.customsClearance ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                  Per Load Type
                </button>

                <div *ngIf="perLoadTypeExpanded.customsClearance" class="load-types-table">
                  <div *ngFor="let loadType of containerLoadTypes" class="load-type-row d-flex align-items-center mb-2">
                    <label class="load-type-label">{{ loadType.label }}</label>
                    <input
                      type="number"
                      class="form-control form-control-sm"
                      [(ngModel)]="formData.customsClearance.loadTypes[getLoadTypeKey(loadType.code)]"
                      [name]="'customsClearance' + loadType.code"
                      placeholder="0">
                  </div>
                </div>
              </div>
            </div>

            <!-- Trucking Fee -->
            <div class="col-md-6">
              <div class="charge-section p-3 border rounded">
                <label class="form-label fw-semibold mb-2">Trucking Fee</label>

                <div class="mb-3">
                  <label class="form-label small text-muted">Charge Basis</label>
                  <select class="form-select form-select-sm" [(ngModel)]="formData.truckingFee.chargeBasis" name="truckingFeeChargeBasis">
                    <option value="">Select charge basis</option>
                    <option *ngFor="let cb of chargeBasisList" [value]="cb.displayName" [title]="cb.notes">
                      {{ cb.displayName }}
                    </option>
                  </select>
                </div>

                <div *ngIf="!perLoadTypeExpanded.truckingFee" class="mb-3">
                  <label class="form-label small text-muted">Value</label>
                  <input type="number" class="form-control form-control-sm" [(ngModel)]="formData.truckingFee.singleValue" name="truckingFeeSingleValue" placeholder="0">
                </div>

                <button type="button" class="btn btn-sm btn-outline-secondary mb-2 w-100" (click)="togglePerLoadType('truckingFee')">
                  <i class="bi" [ngClass]="perLoadTypeExpanded.truckingFee ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                  Per Load Type
                </button>

                <div *ngIf="perLoadTypeExpanded.truckingFee" class="load-types-table">
                  <div *ngFor="let loadType of containerLoadTypes" class="load-type-row d-flex align-items-center mb-2">
                    <label class="load-type-label">{{ loadType.label }}</label>
                    <input
                      type="number"
                      class="form-control form-control-sm"
                      [(ngModel)]="formData.truckingFee.loadTypes[getLoadTypeKey(loadType.code)]"
                      [name]="'truckingFee' + loadType.code"
                      placeholder="0">
                  </div>
                </div>
              </div>
            </div>

            <!-- Export License -->
            <div class="col-md-6">
              <div class="charge-section p-3 border rounded">
                <label class="form-label fw-semibold mb-2">Export License</label>

                <div class="mb-3">
                  <label class="form-label small text-muted">Charge Basis</label>
                  <select class="form-select form-select-sm" [(ngModel)]="formData.exportLicense.chargeBasis" name="exportLicenseChargeBasis">
                    <option value="">Select charge basis</option>
                    <option *ngFor="let cb of chargeBasisList" [value]="cb.displayName" [title]="cb.notes">
                      {{ cb.displayName }}
                    </option>
                  </select>
                </div>

                <div *ngIf="!perLoadTypeExpanded.exportLicense" class="mb-3">
                  <label class="form-label small text-muted">Value</label>
                  <input type="number" class="form-control form-control-sm" [(ngModel)]="formData.exportLicense.singleValue" name="exportLicenseSingleValue" placeholder="0">
                </div>

                <button type="button" class="btn btn-sm btn-outline-secondary mb-2 w-100" (click)="togglePerLoadType('exportLicense')">
                  <i class="bi" [ngClass]="perLoadTypeExpanded.exportLicense ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                  Per Load Type
                </button>

                <div *ngIf="perLoadTypeExpanded.exportLicense" class="load-types-table">
                  <div *ngFor="let loadType of containerLoadTypes" class="load-type-row d-flex align-items-center mb-2">
                    <label class="load-type-label">{{ loadType.label }}</label>
                    <input
                      type="number"
                      class="form-control form-control-sm"
                      [(ngModel)]="formData.exportLicense.loadTypes[getLoadTypeKey(loadType.code)]"
                      [name]="'exportLicense' + loadType.code"
                      placeholder="0">
                  </div>
                </div>
              </div>
            </div>

          </div>

          <hr class="my-3" />

          <!-- Standard Charges Section -->
          <h6 class="fw-semibold mb-3" style="font-size: 0.9rem;">Standard Charges</h6>
          <div class="row g-3 mb-3">

            <!-- CFS -->
            <div class="col-md-6">
              <div class="charge-section p-3 border rounded">
                <label class="form-label fw-semibold mb-2">CFS</label>

                <div class="mb-3">
                  <label class="form-label small text-muted">Charge Basis</label>
                  <select class="form-select form-select-sm" [(ngModel)]="formData.cfs.chargeBasis" name="cfsChargeBasis">
                    <option value="">Select charge basis</option>
                    <option *ngFor="let cb of chargeBasisList" [value]="cb.displayName" [title]="cb.notes">
                      {{ cb.displayName }}
                    </option>
                  </select>
                </div>

                <div *ngIf="!perLoadTypeExpanded.cfs" class="mb-3">
                  <label class="form-label small text-muted">Value</label>
                  <input type="number" class="form-control form-control-sm" [(ngModel)]="formData.cfs.singleValue" name="cfsSingleValue" placeholder="0">
                </div>

                <button type="button" class="btn btn-sm btn-outline-secondary mb-2 w-100" (click)="togglePerLoadType('cfs')">
                  <i class="bi" [ngClass]="perLoadTypeExpanded.cfs ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                  Per Load Type
                </button>

                <div *ngIf="perLoadTypeExpanded.cfs" class="load-types-table">
                  <div *ngFor="let loadType of containerLoadTypes" class="load-type-row d-flex align-items-center mb-2">
                    <label class="load-type-label">{{ loadType.label }}</label>
                    <input
                      type="number"
                      class="form-control form-control-sm"
                      [(ngModel)]="formData.cfs.loadTypes[getLoadTypeKey(loadType.code)]"
                      [name]="'cfs' + loadType.code"
                      placeholder="0">
                  </div>
                </div>
              </div>
            </div>

            <!-- EBS + CSC + DOCS -->
            <div class="col-md-6">
              <div class="charge-section p-3 border rounded">
                <label class="form-label fw-semibold mb-2">EBS + CSC + DOCS</label>

                <div class="mb-3">
                  <label class="form-label small text-muted">Charge Basis</label>
                  <select class="form-select form-select-sm" [(ngModel)]="formData.ebsCscDocs.chargeBasis" name="ebsCscDocsChargeBasis">
                    <option value="">Select charge basis</option>
                    <option *ngFor="let cb of chargeBasisList" [value]="cb.displayName" [title]="cb.notes">
                      {{ cb.displayName }}
                    </option>
                  </select>
                </div>

                <div *ngIf="!perLoadTypeExpanded.ebsCscDocs" class="mb-3">
                  <label class="form-label small text-muted">Value</label>
                  <input type="number" class="form-control form-control-sm" [(ngModel)]="formData.ebsCscDocs.singleValue" name="ebsCscDocsSingleValue" placeholder="0">
                </div>

                <button type="button" class="btn btn-sm btn-outline-secondary mb-2 w-100" (click)="togglePerLoadType('ebsCscDocs')">
                  <i class="bi" [ngClass]="perLoadTypeExpanded.ebsCscDocs ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                  Per Load Type
                </button>

                <div *ngIf="perLoadTypeExpanded.ebsCscDocs" class="load-types-table">
                  <div *ngFor="let loadType of containerLoadTypes" class="load-type-row d-flex align-items-center mb-2">
                    <label class="load-type-label">{{ loadType.label }}</label>
                    <input
                      type="number"
                      class="form-control form-control-sm"
                      [(ngModel)]="formData.ebsCscDocs.loadTypes[getLoadTypeKey(loadType.code)]"
                      [name]="'ebsCscDocs' + loadType.code"
                      placeholder="0">
                  </div>
                </div>
              </div>
            </div>

            <!-- VGM -->
            <div class="col-md-6">
              <div class="charge-section p-3 border rounded">
                <label class="form-label fw-semibold mb-2">VGM</label>

                <div class="mb-3">
                  <label class="form-label small text-muted">Charge Basis</label>
                  <select class="form-select form-select-sm" [(ngModel)]="formData.vgm.chargeBasis" name="vgmChargeBasis">
                    <option value="">Select charge basis</option>
                    <option *ngFor="let cb of chargeBasisList" [value]="cb.displayName" [title]="cb.notes">
                      {{ cb.displayName }}
                    </option>
                  </select>
                </div>

                <div *ngIf="!perLoadTypeExpanded.vgm" class="mb-3">
                  <label class="form-label small text-muted">Value</label>
                  <input type="number" class="form-control form-control-sm" [(ngModel)]="formData.vgm.singleValue" name="vgmSingleValue" placeholder="0">
                </div>

                <button type="button" class="btn btn-sm btn-outline-secondary mb-2 w-100" (click)="togglePerLoadType('vgm')">
                  <i class="bi" [ngClass]="perLoadTypeExpanded.vgm ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                  Per Load Type
                </button>

                <div *ngIf="perLoadTypeExpanded.vgm" class="load-types-table">
                  <div *ngFor="let loadType of containerLoadTypes" class="load-type-row d-flex align-items-center mb-2">
                    <label class="load-type-label">{{ loadType.label }}</label>
                    <input
                      type="number"
                      class="form-control form-control-sm"
                      [(ngModel)]="formData.vgm.loadTypes[getLoadTypeKey(loadType.code)]"
                      [name]="'vgm' + loadType.code"
                      placeholder="0">
                  </div>
                </div>
              </div>
            </div>

            <!-- Manifest -->
            <div class="col-md-6">
              <div class="charge-section p-3 border rounded">
                <label class="form-label fw-semibold mb-2">Manifest</label>

                <div class="mb-3">
                  <label class="form-label small text-muted">Charge Basis</label>
                  <select class="form-select form-select-sm" [(ngModel)]="formData.manifest.chargeBasis" name="manifestChargeBasis">
                    <option value="">Select charge basis</option>
                    <option *ngFor="let cb of chargeBasisList" [value]="cb.displayName" [title]="cb.notes">
                      {{ cb.displayName }}
                    </option>
                  </select>
                </div>

                <div *ngIf="!perLoadTypeExpanded.manifest" class="mb-3">
                  <label class="form-label small text-muted">Value</label>
                  <input type="number" class="form-control form-control-sm" [(ngModel)]="formData.manifest.singleValue" name="manifestSingleValue" placeholder="0">
                </div>

                <button type="button" class="btn btn-sm btn-outline-secondary mb-2 w-100" (click)="togglePerLoadType('manifest')">
                  <i class="bi" [ngClass]="perLoadTypeExpanded.manifest ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                  Per Load Type
                </button>

                <div *ngIf="perLoadTypeExpanded.manifest" class="load-types-table">
                  <div *ngFor="let loadType of containerLoadTypes" class="load-type-row d-flex align-items-center mb-2">
                    <label class="load-type-label">{{ loadType.label }}</label>
                    <input
                      type="number"
                      class="form-control form-control-sm"
                      [(ngModel)]="formData.manifest.loadTypes[getLoadTypeKey(loadType.code)]"
                      [name]="'manifest' + loadType.code"
                      placeholder="0">
                  </div>
                </div>
              </div>
            </div>

            <!-- EDI LSS -->
            <div class="col-md-6">
              <div class="charge-section p-3 border rounded">
                <label class="form-label fw-semibold mb-2">EDI LSS</label>

                <div class="mb-3">
                  <label class="form-label small text-muted">Charge Basis</label>
                  <select class="form-select form-select-sm" [(ngModel)]="formData.ediLss.chargeBasis" name="ediLssChargeBasis">
                    <option value="">Select charge basis</option>
                    <option *ngFor="let cb of chargeBasisList" [value]="cb.displayName" [title]="cb.notes">
                      {{ cb.displayName }}
                    </option>
                  </select>
                </div>

                <div *ngIf="!perLoadTypeExpanded.ediLss" class="mb-3">
                  <label class="form-label small text-muted">Value</label>
                  <input type="number" class="form-control form-control-sm" [(ngModel)]="formData.ediLss.singleValue" name="ediLssSingleValue" placeholder="0">
                </div>

                <button type="button" class="btn btn-sm btn-outline-secondary mb-2 w-100" (click)="togglePerLoadType('ediLss')">
                  <i class="bi" [ngClass]="perLoadTypeExpanded.ediLss ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                  Per Load Type
                </button>

                <div *ngIf="perLoadTypeExpanded.ediLss" class="load-types-table">
                  <div *ngFor="let loadType of containerLoadTypes" class="load-type-row d-flex align-items-center mb-2">
                    <label class="load-type-label">{{ loadType.label }}</label>
                    <input
                      type="number"
                      class="form-control form-control-sm"
                      [(ngModel)]="formData.ediLss.loadTypes[getLoadTypeKey(loadType.code)]"
                      [name]="'ediLss' + loadType.code"
                      placeholder="0">
                  </div>
                </div>
              </div>
            </div>

            <!-- Depot Fee / Gate In Charge -->
            <div class="col-md-6">
              <div class="charge-section p-3 border rounded">
                <label class="form-label fw-semibold mb-2">Depot Fee / Gate In Charge</label>

                <div class="mb-3">
                  <label class="form-label small text-muted">Charge Basis</label>
                  <select class="form-select form-select-sm" [(ngModel)]="formData.depotFee.chargeBasis" name="depotFeeChargeBasis">
                    <option value="">Select charge basis</option>
                    <option *ngFor="let cb of chargeBasisList" [value]="cb.displayName" [title]="cb.notes">
                      {{ cb.displayName }}
                    </option>
                  </select>
                </div>

                <div *ngIf="!perLoadTypeExpanded.depotFee" class="mb-3">
                  <label class="form-label small text-muted">Value</label>
                  <input type="number" class="form-control form-control-sm" [(ngModel)]="formData.depotFee.singleValue" name="depotFeeSingleValue" placeholder="0">
                </div>

                <button type="button" class="btn btn-sm btn-outline-secondary mb-2 w-100" (click)="togglePerLoadType('depotFee')">
                  <i class="bi" [ngClass]="perLoadTypeExpanded.depotFee ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                  Per Load Type
                </button>

                <div *ngIf="perLoadTypeExpanded.depotFee" class="load-types-table">
                  <div *ngFor="let loadType of containerLoadTypes" class="load-type-row d-flex align-items-center mb-2">
                    <label class="load-type-label">{{ loadType.label }}</label>
                    <input
                      type="number"
                      class="form-control form-control-sm"
                      [(ngModel)]="formData.depotFee.loadTypes[getLoadTypeKey(loadType.code)]"
                      [name]="'depotFee' + loadType.code"
                      placeholder="0">
                  </div>
                </div>
              </div>
            </div>

            <!-- EIR -->
            <div class="col-md-6">
              <div class="charge-section p-3 border rounded">
                <label class="form-label fw-semibold mb-2">EIR</label>

                <div class="mb-3">
                  <label class="form-label small text-muted">Charge Basis</label>
                  <select class="form-select form-select-sm" [(ngModel)]="formData.eir.chargeBasis" name="eirChargeBasis">
                    <option value="">Select charge basis</option>
                    <option *ngFor="let cb of chargeBasisList" [value]="cb.displayName" [title]="cb.notes">
                      {{ cb.displayName }}
                    </option>
                  </select>
                </div>

                <div *ngIf="!perLoadTypeExpanded.eir" class="mb-3">
                  <label class="form-label small text-muted">Value</label>
                  <input type="number" class="form-control form-control-sm" [(ngModel)]="formData.eir.singleValue" name="eirSingleValue" placeholder="0">
                </div>

                <button type="button" class="btn btn-sm btn-outline-secondary mb-2 w-100" (click)="togglePerLoadType('eir')">
                  <i class="bi" [ngClass]="perLoadTypeExpanded.eir ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                  Per Load Type
                </button>

                <div *ngIf="perLoadTypeExpanded.eir" class="load-types-table">
                  <div *ngFor="let loadType of containerLoadTypes" class="load-type-row d-flex align-items-center mb-2">
                    <label class="load-type-label">{{ loadType.label }}</label>
                    <input
                      type="number"
                      class="form-control form-control-sm"
                      [(ngModel)]="formData.eir.loadTypes[getLoadTypeKey(loadType.code)]"
                      [name]="'eir' + loadType.code"
                      placeholder="0">
                  </div>
                </div>
              </div>
            </div>

          </div>

          <hr class="my-3" />

          <!-- Air Operational Charges - Read Only Reference -->
          <div class="operational-charges-reference mb-3">
            <div class="d-flex justify-content-between align-items-center mb-2" style="cursor: pointer;" (click)="toggleAirOperational()">
              <div>
                <p class="fw-semibold mb-0" style="font-size: 0.9rem;">Air Operational Charges</p>
                <p class="text-muted mb-0" style="font-size: 0.75rem;">📋 Reference Only - Edit via Operational Charges Management</p>
              </div>
              <i class="bi" [ngClass]="airOperationalExpanded ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </div>

            <div *ngIf="airOperationalExpanded" class="row g-2">
              <div class="col-md-6" *ngFor="let charge of airOperationalCharges">
                <div class="charge-reference-card p-2 border bg-light rounded">
                  <div class="fw-medium small text-muted">{{ charge.feeName }}</div>
                  <div class="text-muted" style="font-size: 0.75rem;">
                    Code: {{ charge.chargeCode }} | {{ charge.chargeBasis }}
                  </div>
                  <div class="text-muted" style="font-size: 0.75rem;">
                    Default: {{ charge.currency }} {{ charge.defaultPrice }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Sea Operational Charges - Read Only Reference -->
          <div class="operational-charges-reference mb-3">
            <div class="d-flex justify-content-between align-items-center mb-2" style="cursor: pointer;" (click)="toggleSeaOperational()">
              <div>
                <p class="fw-semibold mb-0" style="font-size: 0.9rem;">Sea Operational Charges</p>
                <p class="text-muted mb-0" style="font-size: 0.75rem;">📋 Reference Only - Edit via Operational Charges Management</p>
              </div>
              <i class="bi" [ngClass]="seaOperationalExpanded ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </div>

            <div *ngIf="seaOperationalExpanded" class="row g-2">
              <div class="col-md-6" *ngFor="let charge of seaOperationalCharges">
                <div class="charge-reference-card p-2 border bg-light rounded">
                  <div class="fw-medium small text-muted">{{ charge.feeName }}</div>
                  <div class="text-muted" style="font-size: 0.75rem;">
                    Code: {{ charge.chargeCode }} | {{ charge.chargeBasis }}
                  </div>
                  <div class="text-muted" style="font-size: 0.75rem;">
                    Default: {{ charge.currency }} {{ charge.defaultPrice }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <hr class="my-3" />

          <!-- Active Status -->
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div>
              <p class="mb-0 fw-medium small">Active Status</p>
              <p class="text-muted mb-0" style="font-size: 0.75rem;">Enable this rate for use in quotations</p>
            </div>
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" role="switch" [(ngModel)]="formData.isActive" name="isActive" id="activeStatus" style="width: 3rem; height: 1.5rem;">
            </div>
          </div>
        </form>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer border-0 pt-2">
        <button type="button" class="btn btn-sm btn-secondary" (click)="onClose()">Cancel</button>
        <button type="button" class="btn btn-sm btn-primary px-4" (click)="onSave()">Create</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Backdrop -->
<div class="modal-backdrop fade" [class.show]="show" *ngIf="show" style="z-index: 1059;"></div>
